import React from 'react'
import { createContext } from 'lib/createContext'
import { CompanyLocation } from 'api/company/location'
import { LocationEditSchema } from '../locationEditSchema'
import { useParams } from 'react-router'
import { useEditCompanyLocationMutation } from 'queries/company/useEditCompanyLocationMutation'
import { parseErrorMessage } from 'api'
import { toast } from '@workwhile/ui'

type LocationEditModalProviderContextState = {
  state: {
    location: CompanyLocation
    mutationState: {
      isPending: boolean
      errorMessage: string | undefined
    }
  }
  actions: {
    closeModal: () => void
    updateLocation: (data: LocationEditSchema) => void
  }
}

const [Context, useLocationEditModalProviderContextValue] =
  createContext<LocationEditModalProviderContextState>({
    name: 'LocationEditModalProviderContext',
  })

export const LocationEditModalProvider = ({
  children,
  location,
  closeModal,
}: {
  children: React.ReactNode
  location: CompanyLocation
  closeModal: () => void
}) => {
  const { companyId } = useParams<{ companyId: string }>()
  const {
    mutate: updateLocation,
    isPending,
    error,
  } = useEditCompanyLocationMutation(Number(companyId), Number(location.id))

  const value: LocationEditModalProviderContextState = {
    state: {
      location,
      mutationState: {
        isPending,
        errorMessage: parseErrorMessage(error),
      },
    },
    actions: {
      closeModal,
      updateLocation: (data) =>
        updateLocation(data, {
          onSuccess: () => {
            toast.success('Updated location successfully!', {
              position: 'top-center',
            })
            closeModal()
          },
        }),
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useLocationEditModalProviderContextValue }
